// ════════════════════════════════════════════════════════════════════════════
// РЕЗОЛВЕР КАРТИНОК МЕНЮ — перенос src_ui/web/src/screens/menu/photo.ts 1:1.
// Четыре источника фото (предметы, одежда, транспорт, недвижимость), у каждого
// своя нумерация и свой хост внутри зеркала CDN.
//
// ⚠️ ГЛАВНОЕ ПРАВИЛО: фото предметов у majestic по НАШЕМУ ItemId брать НЕЛЬЗЯ —
// у них своя нумерация. Наши предметы живут ТОЛЬКО в зеркале cdn-ra3
// (`cloud/inventoryItems/items`). У majestic берём лишь строковые ключи:
// транспорт (модель) и картинки имущества.
// ════════════════════════════════════════════════════════════════════════════

export const CDN = 'https://cdn.just-rp.online';
/** Зеркало «облака» геймода — здесь нумерация файлов = наши ItemId. */
export const CLOUD = CDN + '/cdn-ra3.ragemp.pro/cloud/';
/** Зеркало majestic — ключи строковые (модель авто, категория имущества). */
const MJ = CDN + '/cdn-world.majestic-files.net/public/master/static/';

/** Фото предмета инвентаря/хранилища по нашему ItemId. */
export const itemPhoto = (itemId) => CLOUD + 'inventoryItems/items/' + itemId + '.png';

/** Фото приза/кейса из набора рулетки (`img/roulette/<name>.png`). */
export const roulettePhoto = (name) => CLOUD + 'img/roulette/' + name + '.png';

/** Фото транспорта по модели GTA (ключ строковый — брать у majestic безопасно). */
export const vehiclePhoto = (model) => MJ + 'img/vehicles/' + String(model || '').toLowerCase() + '.png';

/** Фото бизнеса: kind — папка majestic (item_shops, fuel_stations, ammo_shops …). */
export const propertyPhoto = (kind, n) => MJ + 'img/playermenu/property/' + kind + '/' + n + '.jpg';

/** Фото склада — лежит в другой ветке зеркала, чем бизнесы. */
export const warehousePhoto = (id) => MJ + 'img/property/warehouses/' + id + '.jpg';

/** Домов в зеркале нет — общая карточка дома (её же показывал старый интерфейс). */
export const HOUSE_PHOTO = CDN + '/i.imgur.com/n5Kzqd5.png';

// Подпапки одежды в зеркале — ключ отрицательный ItemId слота (как в getPng.js старого CEF).
const CLOTHES_DIR = {
  [-1]: 'masks', [-2]: 'ears', [-3]: 'gloves', [-4]: 'legs', [-5]: 'bags',
  [-6]: 'shoes', [-7]: 'accessories', [-8]: 'undershit', [-11]: 'tops',
  [-12]: 'hats', [-13]: 'glasses', [-14]: 'watches', [-15]: 'bracelets',
};

/** Фото одежды: `clothes/<пол>/<папка>/<drawable>_<texture>.png`; '' — заглушка. */
export function clothesPhoto(slot, drawable, texture = 0, male = true) {
  const dir = CLOTHES_DIR[slot < 0 ? slot : -slot];
  if (!dir) return '';
  return CLOUD + 'inventoryItems/clothes/' + (male ? 'male' : 'female') + '/' + dir + '/' + drawable + '_' + texture + '.png';
}

/** Разбор поля Data предмета одежды («drawable_texture_isMale») в числа. */
export function parseClothesData(data) {
  const p = String(data || '').split('_');
  return { drawable: Number(p[0]) || 0, texture: Number(p[1]) || 0, male: p[2] !== '0' };
}

// Витрины магазина: готовых картинок на зеркале нет, нарисованы нами и лежат
// рядом с интерфейсом (img/shop) — докопировать при переносе раздела магазина.
export function vipPhoto(id) { return './img/shop/vip' + Math.max(0, Math.min(4, id)) + '.png'; }
export function servicePhoto(id) { return './img/shop/svc' + Math.max(0, Math.min(2, id)) + '.png'; }
export function packPhoto(id) { return './img/shop/pack' + Math.max(0, Math.min(10, id)) + '.png'; }
